/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-01-23 11:31:55
 * @LastEditTime: 2025-08-14 11:00:34
 * @LastEditors: ywj@originqc.com
 */
export const menuNav = [
  {
    id:1,
    title: '本源量子官网',
    link: 'https://originqc.com.cn',
    target: '_blank',
  },
  {
    id:2,
    title: '量子云',
    link: 'https://qcloud.originqc.com.cn/zh',
    target: '_blank',
  },
  {
    id:3,
    title: '本源量子商城',
    link: '/',
    target: '_self',
  },
  {
    id:4,
    title: '本源溯知',
    link: 'https://learn.originqc.com.cn/zh',
    target: '_blank',
  },
  {
    id:5,
    title: '量子应用',
    link: 'https://qcloud.originqc.com.cn/app/finTech',
    target: '_blank',
  },
  {
    id:6,
    title: '科研激励计划',
    link: 'https://qcloud.originqc.com.cn/zh/researchincentive',
    target: '_blank',
  },
]